import React from "react";
import BaseField from "./BaseField";

export default function SliderField({
  field,
  value,
  setValue,
  renderInlineChildren,
  openViewer,
  previewMode = false,
}) {
  const required = !!field.required;
  const label = field.label || "Slider";

  const min = Number(field.config?.min ?? 0);
  const max = Number(field.config?.max ?? 10);
  const step = Number(field.config?.step ?? 1);
  const showValue = field.config?.showValue !== false;

  const currentVal = typeof value === "number" ? value : min;
  const progress = ((currentVal - min) / (max - min)) * 100;

  return (
    <BaseField
      field={field}
      value={value}
      setValue={setValue}
      openViewer={openViewer}
      renderInlineChildren={renderInlineChildren}
      previewMode={previewMode}
    >
      {/* Label */}
      <h3 className="text-gray-800 dark:text-gray-100 text-lg font-bold mb-3 text-center">
        {label} {required && <span className="text-orange-500">*</span>}
      </h3>

      {/* Value preview */}
      {showValue && (
        <p className="text-center mb-2 font-semibold text-gray-800 dark:text-gray-100">
          {currentVal} / {max}
        </p>
      )}

      {/* Slider */}
      <div className="flex items-center gap-3">
        <span className="text-sm text-gray-600 dark:text-gray-300">{min}</span>
        <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={currentVal}
        onChange={(e) => setValue(Number(e.target.value))}
        className="w-full cursor-pointer"
        style={{
          "--range-progress": `${progress}%`
        }}
        />
        <span className="text-sm text-gray-600 dark:text-gray-300">{max}</span>
      </div>
    </BaseField>
  );
}
